import { render, staticRenderFns } from "./deliverylist.vue?vue&type=template&id=70ee1135&"
import script from "./deliverylist.vue?vue&type=script&lang=js&"
export * from "./deliverylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports